import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface IImageEditorFile {
    /** 原始图片 */
    naturalImage: string;
    /** 原始图片大小 M */
    naturalFileSize: number;
    /** 图片名称 */
    naturalFileName: string;
    /** 图片后缀 */
    naturalFileSuffix: string;
    /** 原图信息 */
    originalSize?: string;
}

export enum ImageEditorModelType {
    naturalImage = 'naturalImage',
    naturalFileSize = 'naturalFileSize',
    naturalFileName = 'naturalFileName',
}

export interface IContrast {
    height?: number;
    width?: number;
    isShow?: boolean;
}

export interface IImageEditorModel extends IImageEditorFile {
    destroy: () => void;
    /** 进入编辑入口 : 作图记录:record 新建画布 create 打开图片 open */
    enterType: string;
    setEnterType: (payload: string) => void;

    /** 超过最大提示压缩 10M */
    maxFileSize: number;
    /** 单边超过最大提示压缩 8000px*8000px */
    maxDimensions: number;

    setNaturalImage: (payload: string) => void;

    /** 创建图层 */
    create: (payload: IImageEditorFile) => void;

    /**
     * 对外聚合的 api 接口
     */
    /** 通过名称，获取对应属性值 */
    getStateByName: (payload: {
        payload: any;

        callback: Function;
    }) => void;

    /** 主图是否为透明 */
    isTransparent: boolean;
    /** 设置主图是否为透明 */
    setIsTransparent: (payload: boolean) => void;

    /** 图片编辑对比原图 */
    contrast: IContrast;
    setContrast: (payload: IContrast) => void;
}

const useImageEditorModel = create<IImageEditorModel>()(
    immer((set) => ({
        destroy: () =>
            set((state) => {
                state.naturalImage = '';
                state.naturalFileSize = 0;
                state.naturalFileName = '';
                state.originalSize = '';
                state.isTransparent = false;
                state.contrast = {
                    width: 0,
                    height: 0,
                    isShow: false,
                };
            }),
        // TODO: 这个函数没有发现有在使用，可以删除
        getStateByName: (payload) =>
            set((state) => {
                switch (payload.payload as ImageEditorModelType) {
                    case ImageEditorModelType.naturalImage:
                        payload.callback(state.naturalImage);
                        break;
                    case ImageEditorModelType.naturalFileSize:
                        payload.callback(state.naturalFileSize);
                        break;
                    case ImageEditorModelType.naturalFileName:
                        payload.callback(state.naturalFileName);
                        break;
                    default:
                        payload.callback(null);
                }
            }),
        naturalImage: '',
        setNaturalImage: (payload) =>
            set((state) => {
                state.naturalImage = payload;
            }),
        naturalFileSize: 0,
        naturalFileName: '',
        naturalFileSuffix: '',
        create: (payload) =>
            set((state) => {
                state.naturalImage = payload.naturalImage;
                state.naturalFileSize = payload.naturalFileSize;
                state.naturalFileName = payload.naturalFileName;
                state.naturalFileSuffix = payload.naturalFileSuffix;
                state.originalSize = payload.originalSize;
            }),
        maxFileSize: 10 * 1024,
        maxDimensions: 8000,
        enterType: '',
        setEnterType: (payload) =>
            set((state) => {
                state.enterType = payload;
            }),
        isTransparent: false,
        setIsTransparent: (payload) =>
            set((state) => {
                state.isTransparent = payload;
            }),
        originalSize: '',
        contrast: {
            width: 0,
            height: 0,
            isShow: false,
        },
        setContrast: (payload) =>
            set((state) => {
                state.contrast = { ...state.contrast, ...payload };
            }),
    })),
);

export { useImageEditorModel };
export const getImageEditorModel = () => useImageEditorModel.getState();
